import React from 'react';
import './IndustriesWeServe.css';

const IndustriesWeServe = () => {
  const data = JSON.parse(localStorage.getItem('siteData')) || require('../../siteData.json');
  
  // Sample partners data structure - you can replace this with your actual data
  const partnersData = data.partners || [
    {
      id: 1,
      name: 'Zuche Pharmaceuticals Pvt Ltd.',
      logo: '/assets/images/client1.png',
      type: 'partner'
    },
    {
      id: 2,
      name: 'Hock International India Pvt. Ltd.',
      logo: '/assets/images/client2.png',
      type: 'partner'
    },
    {
      id: 3,
      name: 'Elsker Life sciences Pvt Ltd.',
      logo: '/assets/images/client3.png',
      type: 'partner'
    },
    {
      id: 4,
      name: 'Adrey Engineers Pvt Ltd.',
      
      logo: '/assets/images/client4.png',
      type: 'partner'
    },
    {
      id: 5,
      name: 'Sr TechNserve Pvt Ltd. ',
      logo: '/assets/images/client5.png',
      type: 'partner'
    },
    {
      id: 6,
      name: 'Clicebo Solutions Pvt Ltd.',
      logo: '/assets/images/client6.png',
      type: 'partner'
    },
    {
      id: 7,
      name: ' Imperial Medcare Pvt Ltd.',
      logo: '/assets/images/client7.png',
      type: 'client'
    },
     {
      id: 8,
      name: ' Hindec India Pvt Ltd.',
      logo: '/assets/images/client8.png',
      type: 'client'
    },
    {
      id: 9,
      name: 'Inferrix Greentech Pvt Ltd.',
      logo: '/assets/images/client9.png',
      type: 'partner'
    },
    {
      id: 10,
      name: 'Wisdom Himalayan Voyages Pvt Ltd.',
      logo: '/assets/images/client10.png',
      type: 'partner'
    },
    {
      id: 11,
      name: 'QuicKargo Logistics Pvt Ltd.',
      logo: '/assets/images/client11.png',
      type: 'partner'
    },
    {
      id: 12,
      name: 'Green Chutney Productions.',
      
      logo: '/assets/images/client12.png',
      type: 'partner'
    },
    {
      id: 13,
      name: 'Well Done Media Pvt Ltd',
      logo: '/assets/images/c1.png',
      type: 'partner'
    },
    {
      id: 14,
      name: ' Gauri Kaul Foundation ( Section 8 Company).',
      logo: '/assets/images/client14.png',
      type: 'partner'
    },
    {
      id: 15,
      name: ' Batra Hospital and Medical Research Centre ',
      logo: '/assets/images/client15.png',
      type: 'client'
    }
    
  ];

  return (
    <section className="our-partners">
      <div className="partners-header">
        <br/>
        <br/><h2>
          INDUSTRIES WE SERVE</h2>
      </div>
      
      <div className="partners-container">
        {partnersData.map((partner, index) => (
          <div key={partner.id || index} className="partner-card">
            <div className="partner-logo">
              <img 
                src={partner.logo} 
                alt={partner.name}
                onError={(e) => {
                  // Fallback to placeholder if image fails to load
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="logo-placeholder" style={{display: 'none'}}>
                {partner.name}
              </div>
            </div>
            <div className="partner-name">
              {partner.name}
            </div>
          </div>
        ))}
        
      </div>
   
    </section>
    
  );
};

export default IndustriesWeServe;